import { Box } from '@material-ui/core';
import { AIProductMatchBadge, SText } from '@setvi/shared/components';
// Deep import on purpose: the product-card barrel re-exports no-match, which
// reaches quotes-v2 and circles back into pages/products.
import MatchIndicator from 'pages/auto-rfq/components/product-card/components/match-indicator';

interface AdditionalContentProps {
  percentage: number;
  prefix?: string;
  text: string;
  withBottomBorder?: boolean;
  customChip?: JSX.Element;
  disabled?: boolean;
}
const contentHeight = 80;
const margin = 12;
export const additionalContentHeight = contentHeight + 2 * margin;

export const AdditionalContent = ({
  percentage,
  customChip,
  disabled,
  prefix,
  text,
  withBottomBorder = false
}: AdditionalContentProps) => (
  <Box
    height={contentHeight}
    display="flex"
    alignItems="center"
    width="100%"
    style={{
      borderTop: '1px solid #EEF0F2',
      minHeight: 44,
      borderBottom: withBottomBorder ? '1px solid #EEF0F2' : 'none'
    }}
    py={margin}>
    <Box
      style={{
        gap: 12,
        display: 'flex',
        alignItems: 'center'
      }}>
      {/* Floored at 110 for alignment but free to grow, so the wider status
          labels ("Possible Match") aren't clipped by a fixed width. */}
      <Box
        style={{
          minWidth: 110,
          maxWidth: '40%',
          flexShrink: 0,
          gridGap: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        {!!customChip && customChip}
        {percentage && (
          <AIProductMatchBadge
            value={percentage}
            fontSize={12}
            disabled={disabled}
          />
        )}
        {percentage > 0 && (
          <MatchIndicator percentage={percentage} disabled={disabled} />
        )}
      </Box>

      {!!text && (
        <Box flex={1}>
          <SText
            fontColor={disabled ? '#AFBAC6' : '#333D47'}
            prefix={
              !!prefix && (
                <b
                  style={{
                    color: disabled ? '#AFBAC6' : '#20262D',
                    marginRight: 4
                  }}>
                  {prefix}
                </b>
              )
            }
            size="sm"
            maxLines={3}
            lineHeight="20px"
            title={text}>
            {text}
          </SText>
        </Box>
      )}
    </Box>
  </Box>
);
